module.exports = __webpack_public_path__ + "static/img/5.79ecf00.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/zh/5.png
// module id = QYjU
// module chunks = 0